
<div class="bg" [ngClass]="{'expanded': expand}">
    <div class="container" *ngIf="!expand">
        <p>Want to take your chosen list with you?
            <button class="button brand-button" (click)="expandSection()">Send Now</button>
        </p>
    </div>

    <div class="container">
        <div class="row">
            <div class="col" (click)="expandSection()">
                <span class="float-right" style="margin-top: 0.5rem" aria-label="Close form">
                    <img src="assets/img/cross-white.svg" alt="" srcset="" style="width: 2rem; cursor: pointer;">
                </span>
            </div>
        </div>
    </div>
    <div class="container" *ngIf="expand">
        <div class="row">
            <div class="col-md-6 col-12">
                <h4>
                    <span>
                        Select Your List Once, and We'll Ensure it Lands Straight in Your Inbox
                    </span>
                </h4>
                <br>
                <h4><span>Sounds Good?</span></h4>
                <img src="assets/img/inbox-flight.svg" class="flight-path" alt="">
            </div>
            <div class="col-md-6 col-12">
                <form>
                    <div class="form-group">
                      <input type="text" class="form-control dark-form" id="inputName" aria-describedby="name" placeholder="Enter Name">
                    </div>
                    <div class="form-group">
                      <input type="email" class="form-control dark-form" id="inputEmail" aria-describedby="emailHelp" placeholder="Enter email">
                    </div>
                    <div class="form-group">
                      <input type="number" class="form-control dark-form" id="inputPhone" aria-describedby="phoneHelp" placeholder="Enter Phone No.">
                      <small id="phoneHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
                    </div>

                    <button type="submit" class="btn brand-button" style="width: 100%;">
                      <img src="assets/img/send.svg" alt="" style="width: 1.5rem; margin-right: 0.5rem">
                        Send</button>
                  </form>
            </div>
        </div>
    </div>
</div>

<div class="custom-overlay" (click)="expandSection()" *ngIf="expand"></div>